<style scoped>
.dropdown-item {
    padding: 12px 20px;
    cursor: pointer;
    transition: background-color 0.2s;
    display: flex;
    align-items: center;
    gap: 10px;
    color: rgb(30, 40, 50);
    font-size: 13px;
    font-weight: 500;
    border-bottom: 1px solid rgb(240, 243, 246);
}

.dropdown-item:last-child {
    border-bottom: none;
}

.dropdown-item:hover {
    background-color: rgb(248, 250, 252);
}

.dropdown-item .fa-icon {
    width: 14px;
    height: 14px;
    color: rgb(100, 110, 120);
}
</style>

<template>
    <div class="dropdown-item" @click="$emit('click')">
        <font-awesome-icon v-if="icon" :icon="icon" />
        <span>{{ text }}</span>
    </div>
</template>

<script>
export default {
    name: 'ActionsDropdownItem',
    props: {
        text: {
            type: String,
            required: true
        },
        icon: {
            type: Array,
            default: null
        }
    },
    emits: ['click']
};
</script>
